module.exports = __webpack_public_path__ + "img/building-sms.17bd6e1a.svg";